class FostrVariantRadios extends VariantSelects {
  constructor () {
    super()

    this.sortSizes()
  }

  sortSizes () {
    if (typeof sortSizes !== 'undefined') {
      return window.sortSizes(this.querySelector('fieldset.product-form__input ul.product-form__input__group'))
    }
  }

  onVariantChange () {
    if (this.closest('fostr-shop-the-look')) return
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.fomoMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm && productForm?.handleErrorMesssage) {
      productForm.handleErrorMessage()
    }
  }

  fomoMessage () {
    const variantCurrent = this.currentVariant
    if (!variantCurrent) return
    const variantsInventory = JSON.parse(this.querySelector('#variant-inventory[type="application/json"]').textContent)
    const inventory = variantsInventory.find(variant => variant.id === variantCurrent.id)
    if (!inventory) return
    const fomo = document.querySelector('.product__fomo')
    if (fomo) {
      const overrideThreshold = fomo.dataset.threshold ? Number(fomo.dataset.threshold) : null
      const overrideText = fomo.dataset.text ? String(fomo.dataset.text) : null
      const overrideEnabled = !!((overrideThreshold && overrideText))

      if (overrideEnabled) {
        // Override FOMO message
        if (inventory.inventory > 0 && inventory.inventory <= overrideThreshold) {
          fomo.innerHTML = (overrideText && overrideText !== '') ? overrideText : '&nbsp;'
        } else {
          fomo.innerHTML = ''
        }
      } else {
        // Standard FOMO message
        if (inventory.inventory === 1) {
          fomo.innerHTML = 'Last piece'
        } else if (inventory.inventory === 0) {
          fomo.innerHTML = 'Item Unavailable'
        } else {
          fomo.innerHTML = `${inventory.inventory} left`
        }
      }
    }
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    const allowedValues = ['color', 'colour']
    const colourName = document.querySelector(`.product-connections .form__label span`)

    this.options = fieldsets.map((fieldset) => {
      const colourElement = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
      if (colourElement && allowedValues.includes(colourElement.name.toLowerCase()) && colourName) {
        colourName.innerHTML = colourElement.value
      }
      return colourElement?.value
    })
  }
}

customElements.define('fostr-variant-radios', FostrVariantRadios)

class FostrVariantSelects extends VariantSelects {
  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm && productForm?.handleErrorMesssage) {
      productForm.handleErrorMessage()
    }
  }
}
customElements.define('fostr-variant-selects', FostrVariantSelects)

if (customElements.get('product-swatch') === undefined) {
  customElements.define('product-swatch', class extends HTMLElement {
    connectedCallback () {
      this.label = this.querySelector('[data-product-swatch-el="label"]')

      if (!this.label) return

      this.colours = this.querySelectorAll('[data-product-swatch-el="colour"]')

      this.colours.forEach((colour) => {
        colour.addEventListener('mouseenter', () => {
          this.label.innerHTML = colour.dataset.name
        })
        colour.addEventListener('mouseleave', () => {
          this.label.innerHTML = '&nbsp;'
        })
      })

      this.addEventListener('mouseleave', () => {
        this.label.innerHTML = this.label.dataset.name
      })

      const swatchesLoadedEvent = new CustomEvent('GA_SWATCHES_LOADED', {
        detail: {
          swatchesEl: this,
        },
      })
      window.dispatchEvent(swatchesLoadedEvent)
    }
  })
}
